export default {"src":"/_next/static/media/CECA_Home_Icon_Shield.7234bd6d.svg","height":50,"width":50};